/**
 * Canonical age-group options for centres (rooms).
 *
 * Single source of truth — any UI that lets an admin pick which age
 * groups a centre supports MUST import from here so we never end up
 * with drift between the org-signup wizard, the admin's centre-edit
 * modal, and the render on the centres list.
 *
 * Values are stored on `organizations.centers[].age_groups` and
 * `enrollments.child_age_group`. Change the label WITHOUT changing
 * the stored key and you will break existing data — always add a new
 * entry rather than renaming.
 */

// Ordered from youngest → oldest. Used verbatim as both the stored key
// AND the display label — keeps things simple for a UK nursery ERP.
export const AGE_GROUP_OPTIONS = [
  '0-2',
  '2-3',
  '3-5',
  '5-8',
  '8-11',
  '11-15',
];

// Conservative default set for a brand-new centre. Most UK nurseries
// only serve 0-5, so we pre-check those three and let the owner
// enable extra bands (breakfast/after-school & pre-teen clubs) via
// the centre-edit modal.
export const DEFAULT_CENTER_AGE_GROUPS = ['0-2', '2-3', '3-5'];

// Human-readable friendly label for each key. Currently identical to
// the key but exposed as a mapping so we can pluralise / decorate
// later without touching the storage format.
export function formatAgeGroupLabel(key) {
  return key ? `${key} yrs` : '';
}
